import { render, staticRenderFns } from "./SurveyFillerAgeConfirmation.vue?vue&type=template&id=380abde5&scoped=true"
import script from "./SurveyFillerAgeConfirmation.vue?vue&type=script&lang=js"
export * from "./SurveyFillerAgeConfirmation.vue?vue&type=script&lang=js"
import style0 from "./SurveyFillerAgeConfirmation.vue?vue&type=style&index=0&id=380abde5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380abde5",
  null
  
)

export default component.exports